import { navigation } from '../app/navigation.js';
import { settings } from '../app/settings.js';
import { PanelBase } from '../ui/panel_base.js';
import { loadScript } from '../util/util.js';

/**
 * The store panel.
 */
class StorePanel extends PanelBase {
  static id = navigation.kStorePanelId;

  static markup = `
    <div id='my-store-86848879'></div>
  `;

  async switchOn() {
    if (!this.#storeInitialized && !settings.storeDisabled) {
      await loadScript(
        `https://app.ecwid.com/script.js?86848879&data_platform=code&data_date=2023-04-21`
      );
      window.xProductBrowser(
        'categoriesPerRow=3',
        'views=grid(20,3) list(60) table(60)',
        'categoryView=grid',
        'searchView=list',
        'id=my-store-86848879'
      );
      this.#storeInitialized = true;
    }

    super.switchOn();
  }

  get pageTitle() {
    return `Gift Shop | CamperAid`;
  }

  get historyState() {
    return [
      {
        page: this.page,
        params: this.params,
      },
      this.pageTitle,
      `${window.location.origin}/store`,
    ];
  }

  #storeInitialized;
}

navigation.registerPanel(StorePanel);

export { StorePanel };
